module.exports = __webpack_public_path__ + "img/homePei2.30a513ea.png";